import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';
import Moment from 'react-moment';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          Copyright © <Moment format="YYYY">{new Date()}</Moment> The Ab Lab. All rights reserved. Patent pending.
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
